<template>
  <Dialog
    v-model:visible="visible"
    :header="t('global.shipment.create_title')"
    :style="{width: '50vw'}"
    :modal="props.modal"
    @hide="close()"
  >

    <p v-if="props.address">
      <FormField componentType="custom" title="Shipping address">
        {{ props.address }}
      </FormField>
    </p>

    <form @submit.prevent="submit()">
      <div class="p-fluid">
        <FormField v-model="shipment.tracking_number" :title="t('cruds.shipment.fields.tracking_number')" :required="true" :error="getError('tracking_number')" autofocus />
        <FormField :title="t('cruds.shipment.fields.carrier')" componentType="select" optionLabel="label" optionValue="value" v-model="shipment.carrier" :options="carriers" :error="getError('carrier')"/>
      </div>
    </form>

    <template #footer>
      <Button :label="t('global.cancel')" icon="pi pi-times" class="p-button-text" @click="close()"/>
      <Button :label="t('global.create')" icon="pi pi-check" @click="submit()" class="p-mr-0"/>
    </template>
  </Dialog>
</template>

<script setup>
import {reactive, ref, watch} from 'vue';
import {useForm} from "../hooks/useForm";
import FormField from "../components/FormField";
import {useShipment} from "../hooks/useShipment";
import {useI18n} from 'vue-i18n';

const emit = defineEmits(['update:visible', 'close']);
const props = defineProps({
  visible: {type: Boolean, default: false, required: true},
  modal: {type: Boolean, default: true},
  campaignId: {type: Number, required: true},
  recipientId: {type: Number, required: true},
  address: {type: String, default: ''},
})

const {t} = useI18n({useScope: 'global'})
const visible = ref(props.visible);
const {createShipments, getCarriers} = useShipment();
const carriers = ref((await getCarriers()).data);
const shipment = reactive({
  tracking_number: undefined,
  carrier: undefined,
  campaign_id: props.campaignId,
  recipient_id: props.recipientId,
});

watch(() => visible, (newValue) => emit('update:visible', newValue))
watch(() => props.visible, (newValue) => visible.value = newValue)

const {busy, submit, getError, reset} = useForm(async () => {
  await createShipments(shipment);
  emit('close');
  close();
});

const close = () => {
  emit('update:visible', false);
}
</script>

